<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-chart-line"></i>
          상황판
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">Main</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Welcome</a>
          </li>
      </ul>
    </div>
    <b-card>
      <b-row class="text-center" style="font-size: 1.45rem;">
        <b-col md="4">
          <b style="color : #3D63BA">분석 기간 :</b>
          <b> {{'최근 24 시간 기준' }}</b>
        </b-col>
        <b-col md="4">
          <b style="color : #3D63BA">새로고침 간격: {{refresh}}</b>
          <b> 분</b>
        </b-col>
        <b-col md="4">
          <b style="color : #3D63BA">보안 위협 레벨 : </b>
          <b-badge v-if="UWSS_status == 2" variant="danger">위험</b-badge>
          <b-badge v-else-if="UWSS_status == 1" variant="warning">주의</b-badge>
          <b-badge v-else variant="success">안전</b-badge>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="mb-1">
      <b-row class="mb-2">
        <b-col md="1" sm="1" xl="1"></b-col>
        <b-col md="2" sm="2" xl="2">
          <b-badge variant="dark">&nbsp;&nbsp;&nbsp;</b-badge> <b> 상관관계 분석</b>
        </b-col>
        <b-col>
          상관관계로 악의적인 공격이 추론됩니다
        </b-col>
        <b-col md="2" sm="2" xl="2">
          <b-badge variant="danger">&nbsp;&nbsp;&nbsp;</b-badge> <b> 위험</b>
        </b-col>
        <b-col>
          웹 공격이 지속적이며, 보안점검이 필요합니다
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col md="1" sm="1" xl="1"></b-col>
        <b-col md="2" sm="2" xl="2">
          <b-badge variant="success">&nbsp;&nbsp;&nbsp;</b-badge> <b> 안전</b>
        </b-col>
        <b-col>
          웹 공격이나 보안사고 징후가 없습니다.
        </b-col>
        <b-col md="2" sm="2" xl="2">
          <b-badge variant="warning">&nbsp;&nbsp;&nbsp;</b-badge> <b> 주의</b>
        </b-col>
        <b-col>
          웹 공격이 발생하였고 주의가 필요합니다.
        </b-col>
      </b-row>

        <!-- <b-badge variant="warning">&nbsp;&nbsp;&nbsp;</b-badge> <b> Caution</b>
          <p>Web attack occurs and requires attention</p>
        <b-col>
          <b-row>
            <b-col md="4">
              <b-badge variant="danger">&nbsp;&nbsp;&nbsp;</b-badge> <b> Danger</b>
            </b-col>
            <pre>Successful web attack, signs of incidents<br>No Sign of web attack, but occurs incidents</pre>
          </b-row>
        </b-col> -->
        <!-- <b-col>
          <b-row>
            <b-badge variant="warning">&nbsp;&nbsp;&nbsp;</b-badge> <b> Caution</b>
            <p>Web attack occurs and requires attention</p>
            <b-col md="4">

            </b-col>
            <b-col md="4">

            </b-col>
          </b-row>
        </b-col> -->
        <!-- <b-col>
          <b-row>
            <b-col md="4">
              <b-badge variant="success">&nbsp;&nbsp;&nbsp;</b-badge> <b> Safety</b>
            </b-col>
            <pre>No sign of web attack and security incidents</pre>
          </b-row>
        </b-col> -->
      <!-- </b-row> -->
    </b-card>
    <hr v-if="UWSS_analysis.length > 0">
    <b-row v-if="UWSS_analysis.length > 0">
      <b-col>
        <b-card v-if="UWSS_analysis.length > 0">
          <!-- 여기서 연관 분석으로 보여 줘야 함 -->
          <center>
            통합 웹 보안 보호 상태
          </center>
          <hr>
          <b-row class="row justify-content-center">
            <correlaction  v-for="(info, index) in UWSS_analysis" :hot="hot" v-bind:key="index" :info="info"></correlaction>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <hr>
    <center> 개별 웹 보안 서비스 현황 </center>
    <hr>
    <b-row>
      <b-col v-if="auth && auth.license && auth.license.WEBCastle.use == true">
        <b-card>
          <center>
            웹 해킹 공격 보호 (with <span style="cursor:pointer; color:#08a0e6; font-weight:bold" @click="$router.push({ name : 'webcastle_log' })">WEBCastle</span>)
          </center>
          <hr>
          <b-row class="row justify-content-center">
            <webcastle-item  v-for="dashboard_wc in WC" :key="dashboard_wc.index" :wc="dashboard_wc" :wc_pong_list="wc_pong_list"></webcastle-item>
          </b-row>
        </b-card>
      </b-col>
      <b-col v-if="auth && auth.license && auth.license.WSFinder.use == true">
        <b-card>
          <center>
            웹쉘 설치 보호 (with <span style="cursor:pointer; color:#08a0e6; font-weight:bold" @click="$router.push({ name : 'wsfinder_detect' })">WSFinder</span>)
          </center>
          <hr>
          <b-row class="row justify-content-center" v-if="auth.profile.service != 'pro'">
            <wsfinder-item  v-for="dashboard_wsf in WSF" :key="dashboard_wsf.index" :wsf="dashboard_wsf" :wsf_pong_list="wsf_pong_list"></wsfinder-item>
          </b-row>
          <b-row  class="row justify-content-center" v-else>
            <p> WSFinder가 없습니다. </p>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="auth && auth.license && auth.license.WFDetect.use == true">
        <b-card>
           <center>
             웹 위변조 보호 (with <span style="cursor:pointer; color:#08a0e6; font-weight:bold" @click="$router.push({ name : 'integrity_detect' })">WFDetector</span>)
           </center>
           <hr>
           <b-row  class="row justify-content-center">
             <wfdetect-item  v-for="dashboard_wf in WF" :key="dashboard_wf.index" :wf="dashboard_wf"></wfdetect-item>
           </b-row>
         </b-card>
       </b-col>
      <b-col v-if="auth && auth.license && auth.license.WMDS.use == true">
        <b-card>
          <center>
            웹 악성코드 배포 보호 (with <span style="cursor:pointer; color:#08a0e6; font-weight:bold" @click="$router.push({ name : 'wmds_detect' })">WMDS</span>)
          </center>
          <hr>
          <b-row  class="row justify-content-center">
            <wmds-item  v-for="dashboard_wmds in WMDS" :key="dashboard_wmds.index" :wmds="dashboard_wmds"></wmds-item>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
